import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import styles from "./CitationBottomSheet.module.scss";
import useCitationModalLogic from "../../hooks/useCitationModalLogic";
import CitationContent from "./CitationContent";

const CitationBottomSheet = (props) => {
  const {
    citationNumber,
    displayText,
    fallbackUrl,
    hasPubMed,
    handlePubMedClick,
    handleUrlClick,
    multipleCitations: processedMultipleCitations,
    hasMultipleCitations,
    handleClose,
    handleViewAllReferences,
    getClassNames,
  } = useCitationModalLogic(props);

  const classNames = getClassNames(styles);

  if (hasMultipleCitations && processedMultipleCitations?.length > 0) {
    const modalContent = (
      <div className={styles.citationBackdrop} onClick={handleClose}>
        <div
          className={styles.citationModal}
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles.citationHeader}>
            <button
              className={styles.citationCloseBtn}
              onClick={handleClose}
              aria-label="Close references"
              type="button"
            >
              <i className="tg-icons-Cross"></i>
            </button>
            <div className={styles.citationTitle}>References</div>
            <div className={styles.headerSpacer}></div>
          </div>

          <div className={styles.citationBody}>
            <div className={styles.multipleCitationsContainer}>
              {processedMultipleCitations.map((citation, index) => (
                <div key={citation.number || index} className={styles.citationEntry}>
                  <CitationContent
                    citationNumber={citation.number}
                    displayText={citation.displayText}
                    fallbackUrl={citation.fallbackUrl}
                    hasPubMed={citation.hasPubMed}
                    onPubMedClick={citation.handlePubMedClick}
                    onUrlClick={citation.handleUrlClick}
                    onViewAllReferences={handleViewAllReferences}
                    styles={styles}
                    classNames={classNames}
                    showCitationNumber={true}
                    hidePubMedWhenEmpty={true}
                    viewAllButtonText=""
                  />
                  {index < processedMultipleCitations.length - 1 && (
                    <div className={styles.citationSeparator}></div>
                  )}
                </div>
              ))}
            </div>
            <div className={styles.citationNavigation}>
              <button className={styles.viewAllButton} onClick={handleViewAllReferences}>
                <span className={styles.viewAllText}>All References</span>
                <i className={`tg-icons-LeftArrow ${styles.viewAllArrow}`}></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    return createPortal(modalContent, document.body);
  }

  const modalContent = (
    <div className={styles.citationBackdrop} onClick={handleClose}>
      <div
        className={styles.citationModal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={styles.citationHeader}>
          <button
            className={styles.citationCloseBtn}
            onClick={handleClose}
            aria-label="Close reference"
            type="button"
          >
            <i className="tg-icons-Cross"></i>
          </button>
          <div className={styles.citationTitle}>
            Reference{citationNumber ? ` [${citationNumber}]` : ""}
          </div>
          <div className={styles.headerSpacer}></div>
        </div>

        <div className={styles.citationBody}>
          <CitationContent
            citationNumber={citationNumber}
            displayText={displayText}
            fallbackUrl={fallbackUrl}
            hasPubMed={hasPubMed}
            onPubMedClick={handlePubMedClick}
            onUrlClick={handleUrlClick}
            onViewAllReferences={handleViewAllReferences}
            styles={styles}
            classNames={classNames}
            viewAllButtonText="All References"
            hidePubMedWhenEmpty={true}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

CitationBottomSheet.propTypes = {
  citationNumber: PropTypes.number,
  citationText: PropTypes.string,
  fullReferenceText: PropTypes.string,
  multipleCitations: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      fullReferenceText: PropTypes.string.isRequired,
    }),
  ),
  onClose: PropTypes.func.isRequired,
  onViewAllReferences: PropTypes.func.isRequired,
};

export default CitationBottomSheet;
